export const TIKTOK_CLICK_ID_STORAGE_KEY = 'z_tt_ttclid';
